export const FETCH_CUSTOMER_DETAILS_LIST = "FETCH_CUSTOMER_DETAILS_LIST";
export const FETCH_SINGLE_CUSTOMER_DETAIL = "SINGLE_CUSTOMER_DETAIL";
export const UPDATE_CUSTOMER_DETAIL = "UPDATE_CUSTOMER_DETAIL";
export const FETCH_CUSTOMER_ADDRESS_DETAIL = "FETCH_CUSTOMER_ADDRESS_DETAIL";
export const UPDATE_CUSTOMER_ADDRESS = "UPDATE_CUSTOMER_ADDRESS";
export const FETCH_CUSTOMER_APPOINTMENTS = "FETCH_CUSTOMER_APPOINTMENTS";
